import { mapConfig } from "./map-config";

/**
 * Get percentage zoomed based on max and min
 *
 * Provide min and max, otherwise defaults to map config
 * @param zoom [number] Current zoom
 * @param min [number] Optional - min zoom
 * @param max [number] Optional - max zoom
 */
export const getPercentZoomed = (zoom: number, min?: number, max?: number) => {
  const maxZoom = min || mapConfig.zoom.max;
  const minZoom = max || mapConfig.zoom.min;

  const zoomScale = maxZoom - minZoom;
  const currentScale = zoom - minZoom;

  return 1 - currentScale / zoomScale;
};
